import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import {
  setBrokerSelfRequestFormWidgetActive,
  setBrokerSelfRequestFormWidgetLoading,
} from '../../actions/brokerSelfRequestFormWidget';
import { BrokerConsultantBanner } from '../../components/BrokerConsultantBanner';
import { BrokerFlightBanner } from '../../components/BrokerFlightBanner';
import {
  selectBrokerConsultantBannerButtonText,
  selectBrokerFlightEnabled,
} from '../../selectors/brokerConsultantBanner';
import { selectBrokerSelfRequestFormWidgetLoading } from '../../selectors/brokerSelfRequestFormWidget';
import { getUser } from '../../selectors/user';
import { TTypedThunkDispatch } from '../../types/thunk';
import { trackBannerClick, trackBannerShow } from './tracking';

export const BrokerSelfRequestFormBannerContainer: React.FC = () => {
  const dispatch: TTypedThunkDispatch = useDispatch();

  const buttonText = useSelector(selectBrokerConsultantBannerButtonText);
  const loading = useSelector(selectBrokerSelfRequestFormWidgetLoading);
  const user = useSelector(getUser);
  const isFlightEnabled = useSelector(selectBrokerFlightEnabled);

  const activateWidget = React.useCallback(() => {
    dispatch(setBrokerSelfRequestFormWidgetLoading(true));
    dispatch(setBrokerSelfRequestFormWidgetActive(true));
  }, [dispatch]);

  const handleButtonClick = React.useCallback(() => {
    trackBannerClick();

    if (!user.isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => activateWidget,
        }),
      );

      return;
    }

    activateWidget();
  }, [dispatch, user, activateWidget]);

  // TODO: Удалить в CD-251393.
  if (isFlightEnabled) {
    return (
      <ActionAfterViewObserver callback={trackBannerShow}>
        <BrokerFlightBanner buttonText={buttonText} buttonLoading={loading} onClick={handleButtonClick} />
      </ActionAfterViewObserver>
    );
  }

  return (
    <ActionAfterViewObserver callback={trackBannerShow}>
      <BrokerConsultantBanner buttonText={buttonText} buttonLoading={loading} onClick={handleButtonClick} />
    </ActionAfterViewObserver>
  );
};
